import { render, staticRenderFns } from "./seasonTotalPoint.vue?vue&type=template&id=1de4e4ae&"
import script from "./seasonTotalPoint.vue?vue&type=script&lang=js&"
export * from "./seasonTotalPoint.vue?vue&type=script&lang=js&"
import style0 from "./seasonTotalPoint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports